"use client";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay, EffectFade } from "swiper/modules";
import axios from "axios";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

const Hero = () => {
  const [heroData, setHeroData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [lang, setLang] = useState(localStorage.getItem("lang") || "en");

  useEffect(() => {
    const handleStorageChange = () => {
      setLang(localStorage.getItem("lang") || "en");
    };
    window.addEventListener("storage", handleStorageChange);
    const interval = setInterval(handleStorageChange, 500);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
      clearInterval(interval);
    };
  }, []);

  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const normalizePath = (path = "") => path.replace(/\\/g, "/");

  useEffect(() => {
    const fetchHero = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/api/hero`);
        if (response.data.success) {
          setHeroData(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching hero data:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchHero();
  }, [BASE_URL]);

  if (isLoading || !heroData) {
    return (
      <div className="h-[100vh] bg-[#1A1A1A] flex items-center justify-center text-[#F5F0E8] font-serif">
        Loading...
      </div>
    );
  }

  return (
    <section className="relative w-full h-[60vh] md:h-[90vh] overflow-hidden">

      <Swiper
        modules={[Pagination, Autoplay, EffectFade]}
        effect="fade"
        pagination={{ clickable: true }}
        autoplay={{ delay: 5000, disableOnInteraction: false }}
        loop={true}
        className="w-full h-full"
      >
        {heroData.slides.map((slide, index) => {
          const bgUrl = `${BASE_URL}/${normalizePath(slide.bgImage)}`;

          return (
            <SwiperSlide key={slide._id || index}>
              <div
                className="relative flex items-center w-full h-full bg-center bg-cover"
                style={{ backgroundImage: `url("${bgUrl}")` }}
              >
                {/* OVERLAY */}
                <div className="absolute inset-0 bg-[#0D1B2A]/50" />

                {/* CONTENT */}
                <div className="container relative z-10 mx-auto px-6 md:px-12 max-w-7xl flex items-center h-full">

                  <div className="flex flex-col items-start text-left max-w-2xl">

                    {/* TITLE */}
                    <h1 className="text-[#F5F0E8] text-2xl md:text-4xl lg:text-5xl leading-tight mb-6 font-serif">
                      {slide.title?.[lang]}
                    </h1>

                    {/* DESC */}
                    <p className="text-[#999999] text-[14px] md:text-[16px] mb-10 leading-relaxed">
                      {slide.desc?.[lang]}
                    </p>

                    {/* CTA TEXT */}
                    <div className="flex gap-6 text-[14px] font-medium">

                      {slide.btn1Text?.[lang] && (
                        <Link to="/contact" className="text-[#F5F0E8] hover:text-[#B08D57] transition">
                          {slide.btn1Text[lang]} →
                        </Link>
                      )}

                      {slide.btn2Text?.[lang] && (
                        <Link to="/contact" className="text-[#999999] hover:text-[#B08D57] transition">
                          {slide.btn2Text[lang]} →
                        </Link>
                      )}

                    </div>

                  </div>
                </div>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>

      {/* PAGINATION */}
      <style jsx global>{`
        .swiper-pagination-bullet {
          background: #ffffff;
          opacity: 0.3;
          height: 2px;
          width: 30px;
        }
        .swiper-pagination-bullet-active {
          background: #B08D57;
          opacity: 1;
          width: 50px;
        }
      `}</style>
    </section>
  );
};

export default Hero;